import { getCurrencyDisplayLabel } from '../../utils/currencyDisplay';

export { toApiDateTime } from './duesFormUtils';

const pad = (n) => String(n).padStart(2, '0');

export const currentPeriod = () => {
  const now = new Date();
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}`;
};

export const formatPeriodLabel = (period) => {
  if (!period || typeof period !== 'string') return '-';
  const [year, month] = period.split('-');
  if (!year || !month) return period;
  const d = new Date(Number(year), Number(month) - 1, 1);
  if (Number.isNaN(d.getTime())) return period;
  return d.toLocaleDateString('tr-TR', { year: 'numeric', month: 'long' });
};

export const buildMealFormDefaults = (config) => {
  const period = currentPeriod();
  const [year, month] = period.split('-');
  const lastDay = new Date(Number(year), Number(month), 0).getDate();
  const dueDate = `${year}-${month}-${pad(lastDay)}`;

  return {
    period,
    amount: config?.defaultMealPrice ?? '',
    dueDate,
    finalDueDate: '',
    title: `${formatPeriodLabel(period)} Haftalık Yemek`,
    description: '',
  };
};

export const formatMealDate = (dateString) => {
  if (!dateString) return '-';
  const d = new Date(dateString);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' });
};

export const formatMealMoney = (amount, currency = 'TRY') => {
  if (amount == null || Number.isNaN(Number(amount))) return '-';
  const formatted = Number(amount).toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${formatted} ${getCurrencyDisplayLabel(currency)}`;
};
